import React, {Component, PropTypes} from 'react'
import Modal from 'react-modal'
import cs from 'classnames'

import stylesDocCss from './documents.scss'

import i18n from 'lib/i18n'

const _ = i18n('dswizard')

export default class WarningModal extends Component {
    static propTypes = {
        isOpen: PropTypes.bool,
        style: PropTypes.object,
        warningModalOpen: PropTypes.object,
        didClose: PropTypes.func
    }

    render() {
        const { isOpen, style, didClose, warningModalOpen } = this.props
        return (
            <Modal
                isOpen={Boolean(isOpen)}
                style={style}
                contentLabel={""}

                key={"rootComponentOfDsWizardWarningModalKey"}
            >
                <div className={stylesDocCss.documentsModalContent} key="rootComponentOfDsWizardWarningModalContentRenderKey">
                <span className={stylesDocCss.title}>{_('warningModalTitle')}</span>
                    <span className={stylesDocCss.message}>
                        <div className={stylesDocCss.resendModalContainer}>
                            <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)}>{_('warningModalDescription')}</div>

                            {warningModalOpen && <div>{JSON.stringify(warningModalOpen)}</div>}

                        </div>
                    </span>
                    <div className={stylesDocCss.documentsModalButtons}>
                        <div
                            onClick={()=>{
                                this.setState({warningModalOpen: false})
                                didClose()
                            }}
                            className={stylesDocCss.greenButton + " enabled"}
                        >
                            {_("ok")}
                        </div>
                    </div>
            </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/WarningModal.jsx